import { render } from "./CloseBtn.vue?vue&type=template&id=65dbef42&scoped=true"
const script = {}

import "./CloseBtn.vue?vue&type=style&index=0&id=65dbef42&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dbef42"]])

export default __exports__